import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=359d59f7&scoped=true"
import script from "./Loader.vue?vue&type=script&setup=true&lang=ts"
export * from "./Loader.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Loader.vue?vue&type=style&index=0&id=359d59f7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359d59f7",
  null
  
)

export default component.exports